export * from './rating.module';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// C:/projects/wct-nextias-ui/node_modules/ngx-bar-rating/index.js
// module id = ../../../../ngx-bar-rating/index.js
// module chunks = common